import http from "@/http/http.js";
// let baseUrl = "/api/web/action/licenseQuery/springBoard";

let baseURL = "";
if (process.env.NODE_ENV == 'development') {//开发环境
    baseURL = '/api/web/action/licenseQuery/springBoard';
} else if (process.env.NODE_ENV == 'production') {//生产环境
    baseURL = '/web/action/licenseQuery/springBoard';
}

//根据公司得到推荐要办的证书
export function getLicenses(name) {
    return http.post(baseURL, {
        actionType: "getLicenses",
        actionBody: {
            name: name //公司名称
        }
    });
}